import React, { useEffect, useState } from 'react';

import Badge from '@material-ui/core/Badge';
import BallotIcon from "@material-ui/icons/Ballot";
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { connect } from 'react-redux';

import { getNotes } from '../../notes/services/store/actions';
import { getPendingNotesCount } from '../../notes/services/store/reducer';

import Drawer from '@material-ui/core/Drawer';
import { AppBar, Toolbar, Typography, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import List from '@material-ui/core/List';
import Timer from '@material-ui/icons/Timer';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from '@material-ui/icons/Menu';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { history } from '../services/history';
import { AttachFile, Build, Description, FormatListBulleted, Gesture, Home, InsertDriveFile, Person, PhoneAndroid, ShoppingBasket, Settings } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
    list: {
        width: 250,
    },
    fullList: {
        width: 'auto',
    },
    menuButton: {
        marginRight: theme.spacing(2)
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(1)
    },
    toolbar: theme.mixins.toolbar
}));

const MenuLeft = ({ isSign, signOut, roleUser, content, pendingNotes, getNotes, displayName, permissions }) => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [openDialogLogout, setOpenDialogLogout] = useState(false)

    useEffect(() => {
        if (isSign) {
            document.getElementsByClassName("MuiAppBar-root")[0].addEventListener("mouseover", () => {
                setOpen(true)
            });
        }
    }, [isSign])

    useEffect(() => {
        if (!isSign) return;

        const isAdmin = roleUser === "admin" || roleUser === "super";
        if (!isAdmin) return;

        getNotes();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSign, roleUser]);

    const toggleDrawer = (flag) => {
        setOpen(flag)
    }

    const handleLogOut = () => {
        const callback = () => {
            history.push("/login")
            setOpenDialogLogout(false)
        }

        signOut({ callback })
    }

    const isAdmin = roleUser === "admin" || roleUser === "super"
    const isSuper = roleUser === "super"

    // super siempre ve todo; admin sin permissions usa lógica de rol; con permissions usa el campo
    const can = (key) => {
        if (isSuper) return true
        if (!permissions) return isAdmin
        return Boolean(permissions[key])
    }

    const ToolbarCmp = (
        <Toolbar style={{
            minHeight: '40px',
            height: '40px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: 0
        }}>
            <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={() => toggleDrawer(true)}
                style={{ padding: '6px' }}>
                <MenuIcon style={{ fontSize: '20px' }} />
            </IconButton>
        </Toolbar>
    );

    const dialogLogout = (
        <Dialog
            open={openDialogLogout}
        >
            <DialogTitle>Cerrar sesión</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    ¿Seguro que quieres cerrar sesión?
                </DialogContentText>
                <DialogActions>
                    <Button onClick={() => setOpenDialogLogout(false)}>
                        Cancelar
                    </Button>
                    <Button onClick={handleLogOut}>
                        Aceptar
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    )

    const sideList = () => (
        <div
            className={classes.list}
            role="presentation"
            onClick={() => toggleDrawer(false)}
            onKeyDown={() => toggleDrawer(false)}
        >
            <List>
                {/* Nombre de usuario */}
                {displayName && (
                    <>
                        <ListItem style={{ paddingTop: 16, paddingBottom: 12 }}>
                            <ListItemIcon><AccountCircleIcon color="primary" /></ListItemIcon>
                            <ListItemText
                                primary={
                                    <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
                                        {displayName}
                                    </Typography>
                                }
                            />
                        </ListItem>
                        <Divider />
                    </>
                )}

                {can('dashboard') && <Link to={"/dashboard"} style={{ textDecoration: 'none', color: 'initial' }}>
                    <ListItem button key={2}>
                        <ListItemIcon><Home /></ListItemIcon>
                        <ListItemText primary={"Inicio"} />
                    </ListItem>
                </Link>}
                {can('notes') && (
                    <Link to={"/notes"} style={{ textDecoration: 'none', color: 'initial' }}>
                        <ListItem button key={"notes"}>
                        <ListItemIcon>
                            <Badge
                            badgeContent={pendingNotes}
                            color="secondary"
                            max={99}
                            overlap="circle"
                            anchorOrigin={{ vertical: "top", horizontal: "right" }}
                            invisible={pendingNotes === 0}
                            >
                            <BallotIcon />
                            </Badge>
                        </ListItemIcon>
                        <ListItemText primary={"Notas"} />
                        </ListItem>
                    </Link>
                    )}
                {can('repairs') && <Link to={"/"} style={{ textDecoration: 'none', color: 'initial' }}>
                    <ListItem button key={1}>
                        <ListItemIcon><FormatListBulleted /></ListItemIcon>
                        <ListItemText primary={"Reparaciones"} />
                    </ListItem>
                </Link>}
                {can('taskSign') && <Link to={"/task-sign"} style={{ textDecoration: 'none', color: 'initial' }}>
                    <ListItem button key={1}>
                        <ListItemIcon><Gesture /></ListItemIcon>
                        <ListItemText primary={"Firmar Tareas"} />
                    </ListItem>
                </Link>}
                {can('stock') && <Link to={"/stock"} style={{ textDecoration: 'none', color: 'initial' }}>
                    <ListItem button key={2}>
                        <ListItemIcon><Build /></ListItemIcon>
                        <ListItemText primary={"Stock"} />
                    </ListItem>
                </Link>}
                {can('reacondicionados') && <Link to={"/refurbished"} style={{ textDecoration: 'none', color: 'initial' }}>
                    <ListItem button key="reac">
                        <ListItemIcon><PhoneAndroid /></ListItemIcon>
                        <ListItemText primary={"Reacondicionados"} />
                    </ListItem>
                </Link>}
                <Link to={"/public-stock"} style={{ textDecoration: 'none', color: 'initial' }}>
                    <ListItem button key={2}>
                        <ListItemIcon><ShoppingBasket /></ListItemIcon>
                        <ListItemText primary={"Stock público"} />
                    </ListItem>
                </Link>
                <Link to={"/reacondicionados"} style={{ textDecoration: 'none', color: 'initial' }}>
                    <ListItem button key="public-reac">
                        <ListItemIcon><PhoneAndroid /></ListItemIcon>
                        <ListItemText primary={"Reac. público"} />
                    </ListItem>
                </Link>
                {can('clients') && <Link to={"/clients"} style={{ textDecoration: 'none', color: 'initial' }}>
                    <ListItem button key={2}>
                        <ListItemIcon><Person /></ListItemIcon>
                        <ListItemText primary={"Clientes"} />
                    </ListItem>
                </Link>}
                {can('invoices') && <Link to={"/invoices"} style={{ textDecoration: 'none', color: 'initial' }}>
                    <ListItem button key={2}>
                        <ListItemIcon><Description /></ListItemIcon>
                        <ListItemText primary={"Facturas"} />
                    </ListItem>
                </Link>}
                {can('proformas') && <Link to={"/proformas?isProforma=true"} style={{ textDecoration: 'none', color: 'initial' }}>
                    <ListItem button key={2}>
                        <ListItemIcon><InsertDriveFile /></ListItemIcon>
                        <ListItemText primary={"Proformas"} />
                    </ListItem>
                </Link>}
                {can('tickets') && <Link to={"/tickets"} style={{ textDecoration: 'none', color: 'initial' }}>
                    <ListItem button key={2}>
                        <ListItemIcon><AttachFile /></ListItemIcon>
                        <ListItemText primary={"Tickets"} />
                    </ListItem>
                </Link>}
                {can('controlTime') && <Link to={"/control-time-management"} style={{ textDecoration: 'none', color: 'initial' }}>
                    <ListItem button key={2}>
                        <ListItemIcon><Timer /></ListItemIcon>
                        <ListItemText primary={"Control de Tiempo"} />
                    </ListItem>
                </Link>}
                <Divider></Divider>
                <Link to={"/settings"} style={{ textDecoration: 'none', color: 'initial' }}>
                    <ListItem button key={"settings"}>
                        <ListItemIcon><Settings /></ListItemIcon>
                        <ListItemText primary={"Configuración"} />
                    </ListItem>
                </Link>
                <ListItem button key={3} onClick={() => setOpenDialogLogout(true)}>
                    <ListItemIcon><ExitToAppIcon /></ListItemIcon>
                    <ListItemText primary={"Cerrar sesión"} />
                </ListItem>
                <ListItem>
                    <span style={{ fontSize: '12px' }}>
                    {(typeof process !== 'undefined' && process.env && process.env.REACT_APP_VERSION) ? process.env.REACT_APP_VERSION : ''}
                    </span>
                </ListItem>
            </List>
        </div>
    );

    return (
        <div style={{ visibility: 'initial' }}>
            <nav style={{ visibility: 'initial' }}>
                {isSign &&
                    <AppBar position="fixed" style={{ width: '40px', left: 0 }}>
                        {ToolbarCmp}
                    </AppBar>
                }
                <Drawer open={open} onClose={() => toggleDrawer(false)}>
                    {sideList()}
                </Drawer>
                {dialogLogout}
            </nav>
            <main>
                <div className={classes.toolbar} />
                {content}
            </main>
        </div>
    )
}

const mapStateToProps = (state) => ({
  pendingNotes: getPendingNotesCount(state.notes),
});

const mapDispatchToProps = {
  getNotes,
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuLeft);
